import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-answer-product',
  templateUrl: './answer-product.component.html',
  styleUrls: ['./answer-product.component.scss']
})
export class AnswerProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input() list: any;

  @Input() title: any;

  @Input() productName: any;

  @Input() type: any=1;

}
